<template>
  <div>
    <h4 class="uk-text-bold">Book #: {{this.member.bookNum}}</h4>
    <p>Currently Booked? {{(this.member.booked) ? "Yes" : "No"}}</p>
    <p>You have {{this.member.refusals.length}} Refusal(s) and {{this.member.absences.length}} Absence(s)</p>
    <h2>You are currently marked as inactive</h2>
    <p>Please contact the Union Hall at (856) 456-9323 for assistance.</p>
  </div>
</template>

<script>
export default {
  name: "MemberInactive",
  props: {
    member: null
  }
};
</script>



// WEBPACK FOOTER //
// src/components/member_inactive.vue